<template>
    <div class="navBarBox" :style="{ 'color': color, 'background-color': bgcolor, 'padding': tabPadding }">
      <div class="navBar_left">
        <slot name="left">
          <van-icon name="arrow-left" class="backIcon" v-if="leftIcon" @click="leftClick" />
          <span>{{ leftText }}</span>
        </slot>
      </div>
      <div class="navBar_center van-multi-ellipsis--l2">
        <slot name="center">
          {{ title }}
        </slot>
      </div>
      <div class="navBar_right" @click="rightClick">
        <slot name="right">
          {{ rightText }}
        </slot>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: '',
    props: {
      title: {
        type: String,
        default: ''
      },
      leftText: {
        type: String,
        default: ''
      },
      rightText: {
        type: String,
        default: ''
      },
      color: {
        type: String,
        default: '#666'
      },
      bgcolor: {
        type: String,
        default: '#fff'
      },
      leftIcon: {
        type: Boolean,
        default: true,
      },
      leftFun: {
        type: Boolean,
        default: false
      },
      // 是否包含状态栏
      hasStatus: {
        type: Boolean,
        default: false
      }
  
    },
    data() {
      return {
  
      }
    },
    computed: {
      tabPadding() {
        if (this.hasStatus) {
          return '40px 16px 12px'
        } else {
          return '12px 16px'
        }
      }
    },
    methods: {
      leftClick() {
        if (this.leftFun) {
          this.$emit('leftClick')
        } else {
          this.$router.go(-1)
        }
      },
      rightClick() {
        this.$emit('rightClick')
      }
    },
    mounted() {
  
    },
    created() {
  
    },
    watch: {
  
    },
  
    filters: {
  
    }
  }
  </script>
  
  <style lang='less' scoped='scoped'>
  .navBarBox {
    // width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    position: sticky;
    left: 0;
    top: 0;
    z-index: 10;
    box-sizing: border-box;
    .backIcon {
      font-size: 20px;
    }
  
    .navBar_center {
      max-width: 60%;
      font-size: 15px;
      font-weight: bold;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  </style>


// WEBPACK FOOTER //
// src/components/NavBar/index.vue